import { HttpService } from '@/common/services/http.service';

const CategoriesService = {
    CATEGORY_API_HOST: process.env.VUE_APP_ADMIN_HOST,

    get() {
        return HttpService.httpGet(`${this.CATEGORY_API_HOST}/api/category`)
    }
};

export default CategoriesService
